/**
 * Чьё фото показывать в строке расчёта: завод и, если она известна, позиция.
 *
 * Фото хранятся у пары «поставщик + номенклатура», но с 12.10.2026 строку можно
 * завести и на поставщика целиком — с пустой номенклатурой. Сервер ищет по
 * цепочке: сперва фото самой позиции, а если их нет — общие фото поставщика.
 * Поэтому для запроса достаточно одного ID производства: без номенклатуры
 * вопрос «а есть ли у этого завода фото» по-прежнему осмыслен.
 *
 * Вынесено отдельным модулем, потому что таблиц сравнения две: общая и
 * газобетонная. Пока правило жило внутри общей таблицы, газобетонная о нём не
 * знала — и кнопки фото там не было вовсе.
 *
 * Модуль чистый: ни запросов, ни состояния — только выбор цели, поэтому
 * проверяется исполнением.
 */

/**
 * Цель фото для строки расчёта.
 *
 * Номенклатура берётся первая, у которой есть guide_id: строка может везти
 * несколько позиций, но фото показывается для основной — той, по которой строка
 * и считалась. Номенклатуры может не быть вовсе: тогда годится общее фото
 * поставщика, и в запрос уходит пустая строка — ровно то, что сервер понимает
 * как «ищи общие».
 *
 * @param {object} entry — строка расчёта (та же, что уходит в onSelect)
 * @returns {{productionId: (string|number), nomenclatureId: (string|number|null)}|null}
 */
export const getNomenclatureImageTarget = (entry) => {
  const productionId = entry?.comparison?.productionInfo?.ID;

  if (!productionId) {
    return null;
  }

  const nomenclatureId = entry?.materialsToShow?.find((item) => item?.guideId)?.guideId || null;

  return { productionId, nomenclatureId };
};

/**
 * Ключ строки в карте «у кого фото есть». Один формат на обе таблицы: иначе одна
 * и та же пара считалась бы дважды и разными ключами. Строка без номенклатуры
 * получает ключ с пустым хвостом — это отдельная цель, а не та же самая.
 */
export const getNomenclatureImageKey = (entry) => {
  const target = getNomenclatureImageTarget(entry);

  return target ? `${target.productionId}:${target.nomenclatureId ?? ''}` : null;
};
